/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdCampaignDetailsDataStatusSchema = z.enum(['new', 'draft', 'queued', 'pushed', 'ended', 'error'])

export type MetaAdCampaignDetailsDataStatusSchema = z.infer<typeof metaAdCampaignDetailsDataStatusSchema>
